import React, {
  Fragment,
  useEffect,
  useState
} from "react";
import {
  Input,
  Button,
  Label,
  Row,
  Col,
  FormGroup,
  FormFeedback,
  Form
} from "reactstrap";
import { connect } from "react-redux";
import { clearZoneError, updateZone } from "../../store/zones/actions.js";
import Message from "../../CommonData/Data/Message.js";
import { updateForm } from "../../store/form/actions.js";
import VWLoading from "../../components/vwLoading/vwLoading.js";

const EditZone = (props) => {

  const { handleClose, errorMessage, form, isUpdatePending } = props;
  const [zone, setZone] = useState("");

  useEffect(() => {
    const { zoneDetails, clearZoneError } = props;
    if (zoneDetails) {
      setZone({ ...zoneDetails });
      props.updateForm({
        formEditZone: { ...zoneDetails },
        errors: {}
      })
    }
    clearZoneError();
    //--------------------Key-Listener----------------------
    const handleKeyPress = (e) => {
      if (e.key === "Escape") {
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setZone({ ...zone, [name]: value });
    props.updateForm({
      formEditZone: {
        ...form.formEditZone,
        [name]: value
      },
      errors: {
        ...form && form.errors,
        [name]: null,
      }
    });
  }

  const handleZoneActiveChange = () => {
    setZone({ ...zone, isActive: !zone.isActive })
    props.updateForm({
      formEditZone: {
        ...form.formEditZone,
        isActive: !zone.isActive
      },
      errors: {
        ...form && form.errors,
      }
    });
  };

  const handleUpdateZone = (e) => {
    e.preventDefault();
    const { formEditZone } = form || {};
    const { zoneName } = formEditZone || {};
    const currentErrors = {};

    if (!zoneName) {
      currentErrors.zoneName = "Name is required"
    }

    props.updateForm({
      formEditZone: {
        ...form.formEditZone,
      },
      errors: currentErrors,
    })

    if (Object.keys(currentErrors).length === 0) {
      props.updateZone(form.formEditZone);
    }
  };
  return isUpdatePending ? (<VWLoading />) : (
    <Fragment>
      {errorMessage && (
        <Message
          type="danger"
          defaultMessage={errorMessage}
          baseClassName="alert"
        />
      )}
      <Form className="mb-3" name="formUpdateZone" onSubmit={handleUpdateZone}>
        <FormGroup>
          <Label>
            Zone Name<span className="text-danger">*</span>
          </Label>
          <Input
            autoFocus
            type="text"
            name="zoneName"
            placeholder="Enter zone name"
            onChange={handleInputChange}
            value={zone.zoneName}
            invalid={form && form.errors && form.errors.zoneName}
          />
          <FormFeedback>{form && form.errors && form.errors.zoneName}</FormFeedback>
        </FormGroup>
        <FormGroup>
          <Row>
            <Col md={12}>
              <h6 className="fw-bold">Zone Status</h6>
              <small>You can enable or disable the zone.</small>
            </Col>
          </Row>
          {zone && (
            <Row>
              <Col xl={6}>
                <ul className="form-unstyled-list form-status-list mt-2">
                  <li
                    onClick={handleZoneActiveChange}
                    className={`form-status-item ${!zone.isActive ? "active" : ""}`}
                  >
                    Inactive
                  </li>&nbsp;&nbsp;
                  <li
                    onClick={handleZoneActiveChange}
                    className={`form-status-item ${zone.isActive ? "active" : ""}`}
                  >
                    Active
                  </li>
                </ul>
              </Col>
            </Row>
          )}
        </FormGroup>
        <FormGroup className='mt-4'>
          <Button
            type="submit"
            className='me-4'
            size='sm'
            color="success"
            onClick={handleUpdateZone}
          >
            Update
          </Button>
          <Button
            size='sm'
            color="danger"
            onClick={handleClose}
          >
            Cancel
          </Button>
        </FormGroup>
      </Form>
    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  form: state.form.form,
  isUpdatePending: state.zones.isUpdatePending,
  errorMessage: state.zones.errorMessage,
  zoneDetails: state.zones.zoneDetails,
});

const mapDispatchToProps = (dispatch) => ({
  updateForm: (editProductForm) => dispatch(updateForm(editProductForm)),
  updateZone: (data) => dispatch(updateZone(data)),
  clearZoneError: () => dispatch(clearZoneError()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditZone);
